module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00288.7cd5a49d.jpg";